if (!customElements.get('ds-collection-intro')) {
  customElements.define('ds-collection-intro', class extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.ds-chero__intro-content');
      this.preview = this.querySelector('.ds-chero__intro-preview');
      this.button = this.querySelector('.ds-chero__intro-toggle');
      if (!this.content || !this.preview || !this.button) return;

      this.desktopContent ||= this.content.cloneNode(true);
      if (this.dataset.mobileContent) {
        const template = document.createElement('template');
        template.innerHTML = this.dataset.mobileContent;
        this.mobileContent = template.content;
      }
      this.mobileMedia = window.matchMedia('(max-width: 768px)');
      this.isMobile = null;
      this.onViewportChange = () => this.update();
      this.mobileMedia.addEventListener('change', this.onViewportChange);

      this.onToggle = () => {
        this.setExpanded(this.button.getAttribute('aria-expanded') !== 'true', true);
      };
      this.button.addEventListener('click', this.onToggle);
      this.observer = new ResizeObserver(entries => {
        if (entries[0].contentRect.width !== this.width) this.update();
      });
      this.observer.observe(this);
      this.update();
      document.fonts.ready.then(() => {
        if (this.isConnected) this.update();
      });
    }

    disconnectedCallback() {
      this.introAnimation?.cancel();
      this.classList.remove('is-animating');
      this.button?.removeEventListener('click', this.onToggle);
      this.observer?.disconnect();
      this.mobileMedia?.removeEventListener('change', this.onViewportChange);
    }

    update() {
      if (!this.getClientRects().length) return;

      if (this.isMobile !== this.mobileMedia.matches) {
        this.isMobile = this.mobileMedia.matches;
        if (this.mobileContent) {
          const source = this.isMobile ? this.mobileContent : this.desktopContent;
          this.content.replaceChildren(...source.cloneNode(true).childNodes);
        }
        const textContent = this.content.cloneNode(true);
        textContent.querySelectorAll('h2').forEach(heading => heading.remove());
        textContent.querySelectorAll('p, li, br, h3, h4, h5, h6').forEach(block => block.after(' '));
        this.words = textContent.textContent.replace(/\s+/g, ' ').trim().split(/(?<=[\s-])/);
      }

      const expanded = this.classList.contains('is-expanded');
      this.classList.remove('is-expanded');
      const styles = getComputedStyle(this);
      this.width = this.getBoundingClientRect().width
        - parseFloat(styles.paddingLeft) - parseFloat(styles.paddingRight);
      this.classList.remove('is-collapsible');
      this.preview.hidden = true;
      this.button.hidden = true;
      const lineHeight = parseFloat(getComputedStyle(this.content).lineHeight);
      const needsToggle = this.content.scrollHeight > lineHeight * 2 + 1;
      this.classList.toggle('is-collapsible', needsToggle);
      this.button.hidden = !needsToggle;
      this.setExpanded(false);
      if (!needsToggle) {
        this.classList.add('is-ready');
        return;
      }

      const maxHeight = lineHeight * 2
        + parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom) + 1;
      let low = 0;
      let high = this.words.length;
      while (low < high) {
        const middle = Math.ceil((low + high) / 2);
        this.preview.textContent = this.words.slice(0, middle).join('').trimEnd().replace(/[.,;:!?-]+$/, '') + '… ';
        if (this.getBoundingClientRect().height <= maxHeight) {
          low = middle;
        } else {
          high = middle - 1;
        }
      }
      this.preview.textContent = this.words.slice(0, low).join('').trimEnd().replace(/[.,;:!?-]+$/, '') + '… ';
      this.setExpanded(expanded);
      this.classList.add('is-ready');
    }

    setExpanded(expanded, withAnimation = false) {
      const startHeight = withAnimation ? this.getBoundingClientRect().height : 0;
      this.introAnimation?.cancel();
      this.introAnimation = null;
      this.classList.remove('is-animating');
      this.classList.toggle('is-expanded', expanded);
      this.preview.hidden = expanded || !this.classList.contains('is-collapsible');
      this.button.setAttribute('aria-expanded', String(expanded));
      this.button.querySelector('span').textContent = expanded
        ? this.button.dataset.less
        : this.button.dataset.more;

      if (!withAnimation || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const endHeight = this.getBoundingClientRect().height;
      if (startHeight === endHeight) return;

      this.classList.add('is-animating');
      const animation = this.animate([
        { height: `${startHeight}px` },
        { height: `${endHeight}px` }
      ], { duration: 300, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
      this.introAnimation = animation;
      animation.addEventListener('finish', () => {
        if (this.introAnimation !== animation) return;
        this.introAnimation = null;
        this.classList.remove('is-animating');
      }, { once: true });
    }
  });
}
